import { appAxios } from "../axios/axios";
import { IDepartment } from "../interfaces/department.interface";
import { IResponse } from "../interfaces/requestResponse.interface";

export const getDepartmentList = async (): Promise<
  IResponse<IDepartment[]>
> => {
  try {
    const apiResponse = await appAxios.post(
      "/query-management-staff/getCrmDepartmentWithJoins"
    );
    const departmentResponse: IResponse<IDepartment[]> = apiResponse.data;
    return departmentResponse;
  } catch (error: any) {
    return error?.data;
  }
};
